<form [formGroup]="form" class="sectionBlock">
    <div class="row">
        <div class="form-group col-xs-2 col-sm-2 col-md-2 col-lg-2">
            <div class="form-group">
                <div class="mb-3"> Initial <span class="formMandatoryInput">*</span></div>
                <ng-select formControlName="nameInitialsId">
                    <ng-option value="">Select Initial</ng-option>
                    <ng-option *ngFor="let initial of nameInitials" [value]="initial.id">{{initial.name}}</ng-option>
                </ng-select>
                <div *ngIf="Submitted && f['nameInitialsId'].errors" class="formMandatoryInput"
                    style="font-size: 12px;">Initial is
                    reqiured.</div>
            </div>
        </div>
        <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4">
            <div class="form-group">
                <div class="mb-3"> Name <span class="formMandatoryInput">*</span></div>
                <input type="text" class="form-control" placeholder="User Name" formControlName="name">
                <div *ngIf="Submitted && f['name'].errors" class="formMandatoryInput" style="font-size: 12px;">Name is
                    reqiured.</div>
            </div>
        </div>
        <div class="form-group col-xs-2 col-sm-2 col-md-2 col-lg-2">
            <div class="form-group">
                <div class="mb-3"> Initial <span class="formMandatoryInput">*</span></div>
                <ng-select (change)="onRelationInitialChange()" formControlName="relationInitialsId">
                    <ng-option value="">Select Initial</ng-option>
                    <ng-option *ngFor="let initial of initials" [value]="initial.id">{{initial.name}}</ng-option>
                </ng-select>
                <div *ngIf="Submitted && f['relationInitialsId'].errors" class="formMandatoryInput"
                    style="font-size: 12px;">Initial is
                    reqiured</div>
            </div>
        </div>
        <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4">
            <div class="form-group">
                <div class="mb-3"> {{relationNameLabel}} <span class="formMandatoryInput">*</span></div>
                <input type="text" class="form-control" [placeholder]="relationNameLabel" formControlName="fatherHusbandName">
                <div *ngIf="Submitted && f['fatherHusbandName'].errors" class="formMandatoryInput"
                    style="font-size: 12px;">Relation
                    name is reqiured.</div>
            </div>
        </div>
        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
                <div class="mb-3"> Contact Number <span class="formMandatoryInput">*</span></div>
                <input type="text" class="form-control" (keypress)="_keyPress($event)" maxlength="10"
                    placeholder="Contact Number" formControlName="contactNo">
                <div *ngIf="Submitted && f['contactNo'].errors" class="formMandatoryInput" style="font-size: 12px;">
                    Contact number is reqiured.</div>
            </div>
        </div>
        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
                <div class="mb-3"> Email <span class="formMandatoryInput">*</span></div>
                <input type="email" class="form-control" placeholder="Email" formControlName="email">
                <div *ngIf="Submitted && f['email'].errors" class="formMandatoryInput" style="font-size: 12px;">Email is
                    reqiured.</div>
            </div>
        </div>
        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
                <div class="mb-3"> Gender <span class="formMandatoryInput">*</span></div>
                <ng-select formControlName="gender">
                    <ng-option value="">Select Gender</ng-option>
                    <ng-option *ngFor="let gender of genders" [value]="gender.name">{{gender.name}}</ng-option>
                </ng-select>
                <div *ngIf="Submitted && f['gender'].errors" class="formMandatoryInput" style="font-size: 12px;">Gender
                    is reqiured.</div>
            </div>
        </div>
        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
                <div class="mb-3"> Adhar Card No. </div>
                <input type="text" class="aadhar form-control" (keypress)="_keyPress($event)" maxlength="12"
                    placeholder="Adhar Card No" formControlName="aadharNumber">
            </div>
        </div>
        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
                <div class="mb-3"> Pan Card No. <span class="formMandatoryInput">*</span></div>
                <input type="text" class="form-control" placeholder="Pan Card No" formControlName="pancardNo"
                    maxlength="10">
                <div *ngIf="Submitted && f['pancardNo'].errors" class="formMandatoryInput" style="font-size: 12px;">Pan
                    card number is reqiured.</div>
            </div>
        </div>
        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
                <div class="mb-3"> Religion </div>
                <ng-select (change)="getCommnunity()" formControlName="religionId">
                    <ng-option value="">Select Religion</ng-option>
                    <ng-option *ngFor="let religion of religions" [value]="religion.id">{{religion.name}}</ng-option>
                </ng-select>
            </div>
        </div>
        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
                <div class="mb-3"> Community </div>
                <ng-select formControlName="communityId">
                    <ng-option *ngFor="let community of communityList"
                        [value]="community?.id">{{community.name}}</ng-option>
                </ng-select>
            </div>
        </div>
        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
                <label>Profile Image</label> &nbsp;
                <input type="file" class="form-control" name="item" formControlName="paymentTypeCopy" accept="*"
                    (change)="uploadImage($event)" style="font-size: 18px; display: none;" />
                <img src="{{ clientPicAddUpdateIcon }}" height="20" width="20" id="myImg"
                    (click)="setCurrentFileConfig('Photo')">
                <i class="pi pi-eye pi-icons ml-2" aria-hidden="true" (click)="setClickPicView('', '')">
                </i>
            </div>
        </div>
        <div class="col-sm-12">
            <!-- <button type="button" class="btn btn-danger" (click)="close()">Close</button> -->
            <button type="submit" class="btn btn-success mr-2" (click)="onSubmit()">Submit</button>
        </div>
    </div>
</form>
<p-dialog [(visible)]="displayDocumentFileDialogue" [modal]="true" [draggable]="false" [resizable]="false"
    [blockScroll]=false [style]="{ width: '30rem' }" (onHide)="receiveCurrentUserProfilePic($event)">
    <p-header>
        Upload {{ documentFileData?.picFor }} Pic
    </p-header>
    <app-document-file [fileDataConfig]='documentFileData'
        (documentFile)="receiveCurrentUserProfilePic($event)"></app-document-file>
</p-dialog>

<p-dialog [(visible)]="showclickedPic" [draggable]="false" [resizable]="false" [blockScroll]=true [modal]=true
    style="background-color:white; width: 380px;">
    <p-header class="row modal-header1">
        <h5>
            <b>Profile {{ this.profilePicData?.documentSubType }}</b>
        </h5>
    </p-header>
    <div class="modal-body col-sm-12">
        <div class="webcam-image col-sm-6">
            <img [src]="clientImage" width="380" height="300" />
        </div>
    </div>
</p-dialog>